import React, { useState, useEffect, useRef } from "react";
import coverbg from "../assets/largecover.jpg";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBInput,
  MDBCardHeader,
  MDBIcon,
  MDBCardImage,
  MDBCarousel,
  MDBCarouselItem,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem,
} from "mdb-react-ui-kit";
import {
  MDBRadio,
} from "mdb-react-ui-kit";
import html2canvas from "html2canvas";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import logo from "../assets/logo.png";
import logodark from "../assets/logodark.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import car from "../assets/car.png";
import minivan from "../assets/minibus.png";
import van from "../assets/van.png";
import prestige from "../assets/sportscar.png";
import carinv from "../assets/carinv.png";
import "../App.css";
import { Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Slider, TextField } from "@mui/material";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
} from "mdb-react-ui-kit";
import watermark from "../assets/watermarkpng.png"
import adventure from "../assets/adventure.jpg";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import { DatePicker } from "@mui/x-date-pickers";

import para1 from "../assets/para1.jpg";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { ref as reference } from "firebase/storage";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";


import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import {
  ArrowForwardIosOutlined,
  AttachMoney,
  BuildCircle,
  Check,
  ContactPhoneOutlined,
  EmojiEvents,
  Favorite,
  Filter1,
  Filter2,
  Filter3,
  Filter4,
  FilterList,
  LocalGasStation,
  LocalOfferOutlined,
  LocationOffOutlined,
  LocationOnOutlined,
  Looks3,
  Looks4,
  LooksOne,
  LooksTwo,
  Money,
  PeopleAlt,
  SensorDoor,
  UploadFileOutlined,
} from "@mui/icons-material";
import { Parallax } from "react-parallax";
import ReactCardCarousel from "react-card-carousel";
import car1 from "../assets/bmw-m5.jpg";
import cardcover from "../assets/fddlog.jpg";

import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";
import MuiInput from "@mui/material/Input";
import VolumeUp from "@mui/icons-material/VolumeUp";
import { storage } from "../firebase";

import car2 from "../assets/ferrari-enzo.jpg";

import car3 from "../assets/ford-raptor.jpg";
import car4 from "../assets/jeep-renegade.jpg";
import car5 from "../assets/mini-cooper.jpg";
import car6 from "../assets/vw-polo.jpg";

import car7 from "../assets/hyundai-staria.jpg";

import ImageGallery from "react-image-gallery";

import Carousel from "react-bootstrap/Carousel";
import axios from "axios"
import html2pdf from "html2pdf.js";

import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import  {login}  from "../actions/auth";
import { useNavigate } from "react-router-dom";
import vidbg from "../vid.mp4"
import bglogin from "../assets/bglogin.png"
import bgform from "../assets/bgform.jpg"
import { ref } from "firebase/storage";
import emailjs from "emailjs-com";
import Navb from "./Navbar";

const Login = ({  }) => {
  const navigate = useNavigate();
  const [navBackground, setNavBackground] = useState(false);
  const navRef = useRef();
  navRef.current = navBackground;
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 50;
      if (navRef.current !== show) {
        setNavBackground(show);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ref = useRef();
  //getting log in details

  const [loogin, setLogin] = useState({
    email: "",
    password: "",
  });


  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  //pathologies

  const [state, setState] = React.useState({
    gilad: true,
    jason: false,
    antoine: false,
    db: false,
    hp: false,
    cho: false,
  });

  const handlepathos = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };
  

  const { gilad, jason, antoine, db, hp, cho } = state;
  const error =
    [gilad, jason, antoine, db, hp, cho].filter((v) => v).length !== 2;

  //allrgies

 const [textFields, setTextFields] = useState([]);

 const handleTextFieldChange = (index, value) => {
   const updatedTextFields = [...textFields];
   updatedTextFields[index] = { ...updatedTextFields[index], value };
   setTextFields(updatedTextFields);
 };

 const addTextField = () => {
   setTextFields([...textFields, { id: Date.now(), value: "" }]);
 };
  const [Typegrf, setTypegrf] = React.useState("");

  const handleTypegrf = (event) => {
    setTypegrf(event.target.value);
  };

  // file upload
  const [progress, setProgress] = useState(0);
  const [progress1, setProgress1] = useState(0);
  const [progress2, setProgress2] = useState(0);
  const [progress3, setProgress3] = useState(0);

  const [imagepc, setimagepc] = useState(false);
  const [imagepc1, setimagepc1] = useState(false);
  const [imagepc2, setimagepc2] = useState(false);
  const [imagepc3, setimagepc3] = useState(false);

  const [imagePC, setimagePC] = useState("");
  const [imagePC1, setimagePC1] = useState("");
  const [imagePC2, setimagePC2] = useState("");
  const [imagePC3, setimagePC3] = useState("");

  const [photo, setphoto] = useState(false);
  const [photo1, setphoto1] = useState(false);
  const [photo2, setphoto2] = useState(false);
  const [photo3, setphoto3] = useState(false);

  const [errors2, setErrors2] = useState({});
    const [error4, setError4] = useState({});

  const [errors3, setErrors3] = useState({});
  const [errors1, setErrors1] = useState({});
  const [Imgs, setImgs] = useState([]);

  const formHandler = (e) => {
    e.preventDefault();
    const file = e.target[0].files[0];
    uploadFiles(file);
  };

  const uploadFiles = (file) => {
    setErrors2({});
    //
    if (!file) return;
    const sotrageRef = reference(storage, `files/${file.name}`);

    const uploadTask = uploadBytesResumable(sotrageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setimagePC(downloadURL);
          setphoto(true);
          setImgs((oldArray) => [...oldArray, downloadURL]);
        });
      }
    );
  };










    console.log(Imgs)

    const formHandler1 = (e) => {
      e.preventDefault();
      const file = e.target[0].files[0];
      uploadFiles1(file);
    };

    const uploadFiles1 = (file) => {
      setErrors2({});
      //
      if (!file) return;
      const sotrageRef = reference(storage, `files/${file.name}`);

      const uploadTask = uploadBytesResumable(sotrageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const prog = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress1(prog);
        },
        (error) => console.log(error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setimagePC1(downloadURL);
            setphoto1(true);
            setImgs((oldArray) => [...oldArray, downloadURL]);
          });
        }
      );
    };

  
  
  











    const formHandler2 = (e) => {
    e.preventDefault();
    const file = e.target[0].files[0];
    uploadFiles2(file);
  };

  const uploadFiles2 = (file) => {
    setErrors2({});
    //
    if (!file) return;
    const sotrageRef = reference(storage, `files/${file.name}`);

    const uploadTask = uploadBytesResumable(sotrageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress2(prog);
      },
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setimagePC2(downloadURL);
          setphoto2(true);
          setImgs((oldArray) => [...oldArray, downloadURL]);
        });
      }
    );
  };



















    const formHandler3 = (e) => {
      e.preventDefault();
      const file = e.target[0].files[0];
      uploadFiles3(file);
    };

    const uploadFiles3 = (file) => {
      setErrors2({});
      //
      if (!file) return;
      const sotrageRef = reference(storage, `files/${file.name}`);

      const uploadTask = uploadBytesResumable(sotrageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const prog = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress3(prog);
        },
        (error) => console.log(error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setimagePC3(downloadURL);
            setphoto3(true);
            setImgs((oldArray) => [...oldArray, downloadURL]);
          });
        }
      );
    };


//steps images
  const steps = [
    "Photo de face ",
    "Photo de Profil",
    "Photo de haut",
    "photo Arriere"
  ];



  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };











  //upload pdf
  

const generatePDF = async () => {
  try {
    // Get the component reference
    const element = componentRef.current;

    // Configure options for html2pdf
    const opt = {
      margin: 1,
      filename: `${Date.now()}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    // Generate PDF using html2pdf
    const pdf = await html2pdf().set(opt).from(element).outputPdf("blob");

    // Create a blob from the PDF data
    const blob = new Blob([pdf], { type: "application/pdf" });

    // Upload PDF file to Firebase Storage
    const storageRef = reference(storage, `generated_pdfs/${Date.now()}.pdf`);
    const uploadTask = uploadBytesResumable(storageRef, blob);

    // Listen for state changes during the upload
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Calculate upload progress
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        // Handle any upload errors
        console.error(error);
        setErrors2({ upload: "An error occurred while uploading the PDF." });
      },
      () => {
        // When the upload is complete, get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // Use the download URL, e.g., save it to state or perform any further actions
          console.log("PDF uploaded successfully:", downloadURL);
          setLink(downloadURL);
        });
      }
    );
  } catch (error) {
    // Handle any unexpected errors
    console.error("Error generating or uploading PDF:", error);
    setErrors2({
      upload: "An error occurred while generating or uploading the PDF.",
    });
  }
};








    function getStepContent(step) {
      switch (step) {
        case 0:
          return (
            <React.Fragment>
              <Grid container>
                <Grid xs={12} md={6} lg={6} style={{textAlign:"center"}}>
                  <Typography
                    variant="overline"
                    display="block"
                    gutterBottom
                    style={{ marginTop: "10%" }}
                  >
                    Photo de face de votre visage{" "}
                  </Typography>
                  <img
                    style={{ width: "25%" }}
                    src="https://img.freepik.com/vecteurs-libre/gros-plan-visage-homme_98292-4059.jpg?size=338&ext=jpg&ga=GA1.1.632798143.1705276800&semt=ais"
                  />
                </Grid>
                <Grid xs={12} md={6} lg={6}>
                  <div className="App">
                    <form onSubmit={formHandler}>
                      <input
                        type="file"
                        className="input"
                        style={{ marginTop: "15%", width: "80%" }}
                        onChange={() => {
                          setimagepc(true);
                        }}
                      />
                      {imagepc ? (
                        <>
                          <div>
                            <button
                              className="buttonIm"
                              style={{
                                border: "none",
                                padding: "1%",
                                marginTop: "2%",
                                borderRadius: "12px",
                                backgroundColor: "#34a8eb",
                                fontFamily: " 'Bebas Neue', sans-serif",
                                color: "white",
                              }}
                              onClick={() => {
                                uploadFiles();
                                                    generatePDF();

                              }}
                              type="submit"
                            >
                              <UploadFileOutlined
                                color="primary"
                                sx={{ color: "white", fontSize: "35px" }}
                              />
                              ENVOYER
                            </button>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </form>
                    <hr />
                    {errors2.imagePC && (
                      <p className="error">{errors2.imagePC}</p>
                    )}

                    <p>Uploading done {progress}%</p>
                  </div>
                  {photo ? (
                    <>
                      <div className="Li">
                        <div
                          className="boxclose"
                          onClick={() => {
                            setimagePC("");
                            setphoto(false);
                          }}
                        ></div>
                        <img
                          className="imgV"
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                          src={imagePC}
                          alt=""
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>

              <Button
                onClick={() => {
                  handleNext();
                }}
                style={{ float: "right", marginTop: "-2%" }}
              >
                Next
              </Button>
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <div
                className="mb-4"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Typography
                  variant="overline"
                  display="block"
                  gutterBottom
                  style={{ marginTop: "10%" }}
                >
                  Photo de face de votre visage{" "}
                </Typography>
                <img
                  style={{ width: "30%" }}
                  src="https://cdn5.vectorstock.com/i/1000x1000/53/44/man-face-sideview-vector-23305344.jpg"
                />

                <div className="App">
                  <form onSubmit={formHandler1}>
                    <input
                      type="file"
                      className="input"
                      style={{ marginTop: "15%" }}
                      onChange={() => {
                        setimagepc1(true);
                      }}
                    />
                    {imagepc1 ? (
                      <>
                        <div>
                          <button
                            className="buttonIm"
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => {
                              uploadFiles1();
                            }}
                            type="submit"
                          >
                            <UploadFileOutlined
                              fontSize="meduim"
                              sx={{ color: "black" }}
                            />
                            Upload
                          </button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </form>
                  <hr />
                  {errors3.imagePC1 && (
                    <p className="error">{errors3.imagePC1}</p>
                  )}

                  <p>Uploading done {progress1}%</p>
                </div>
                {photo1 ? (
                  <>
                    <div className="Li">
                      <div
                        className="boxclose"
                        onClick={() => {
                          setimagePC1("");
                          setphoto1(false);
                        }}
                      ></div>
                      <img
                        className="imgV"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        src={imagePC1}
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <Button
                onClick={() => handleNext()}
                style={{ float: "right", marginTop: "-2%" }}
              >
                Next
              </Button>
            </React.Fragment>
          );
        case 2:
          return (
            <React.Fragment>
              <div
                className="mb-4"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Typography
                  variant="overline"
                  display="block"
                  gutterBottom
                  style={{ marginTop: "10%" }}
                >
                  Photo de face de votre visage{" "}
                </Typography>

                <div className="App">
                  <form onSubmit={formHandler2}>
                    <input
                      type="file"
                      className="input"
                      style={{ marginTop: "15%" }}
                      onChange={() => {
                        setimagepc2(true);
                      }}
                    />
                    {imagepc2 ? (
                      <>
                        <div>
                          <button
                            className="buttonIm"
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => {
                              uploadFiles2();
                            }}
                            type="submit"
                          >
                            <UploadFileOutlined
                              fontSize="meduim"
                              sx={{ color: "black" }}
                            />
                            Upload
                          </button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </form>
                  <hr />
                  {errors3.imagePC && (
                    <p className="error">{errors3.imagePC2}</p>
                  )}

                  <p>Uploading done {progress2}%</p>
                </div>
                {photo ? (
                  <>
                    <div className="Li">
                      <div
                        className="boxclose"
                        onClick={() => {
                          setimagePC2("");
                          setphoto2(false);
                        }}
                      ></div>
                      <img
                        className="imgV"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        src={imagePC2}
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <img
                  style={{ width: "30%" }}
                  src="https://media.istockphoto.com/id/147710122/fr/photo/homme-avec-alopecia.jpg?s=612x612&w=0&k=20&c=YauP4ZRauw0WiD5Xffp6w1Bz3FbcR10oaUXceeNL9zk="
                />
              </div>

              <Button
                onClick={() => handleNext()}
                style={{ float: "right", marginTop: "-2%" }}
              >
                Next
              </Button>
            </React.Fragment>
          );
        case 3:
          return (
            <React.Fragment>
              <div
                className="mb-4"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Typography
                  variant="overline"
                  display="block"
                  gutterBottom
                  style={{ marginTop: "10%" }}
                >
                  Photo de face de votre visage{" "}
                </Typography>

                <div className="App">
                  <form onSubmit={formHandler3}>
                    <input
                      type="file"
                      className="input"
                      style={{ marginTop: "15%" }}
                      onChange={() => {
                        setimagepc3(true);
                      }}
                    />
                    {imagepc3 ? (
                      <>
                        <div>
                          <button
                            className="buttonIm"
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => {
                              uploadFiles3();
                            }}
                            type="submit"
                          >
                            <UploadFileOutlined
                              fontSize="meduim"
                              sx={{ color: "black" }}
                            />
                            Upload
                          </button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </form>
                  <hr />
                  {error4.imagePC3 && (
                    <p className="error">{error4.imagePC3}</p>
                  )}

                  <p>Uploading done {progress3}%</p>
                </div>
                {photo ? (
                  <>
                    <div className="Li">
                      <div
                        className="boxclose"
                        onClick={() => {
                          setimagePC3("");
                          setphoto3(false);
                        }}
                      ></div>
                      <img
                        className="imgV"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        src={imagePC3}
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <img
                  style={{ width: "30%" }}
                  src="https://media.istockphoto.com/id/147710122/fr/photo/homme-avec-alopecia.jpg?s=612x612&w=0&k=20&c=YauP4ZRauw0WiD5Xffp6w1Bz3FbcR10oaUXceeNL9zk="
                />
              </div>

              <Button
                onClick={() => {
                  handleNext();
                  generatePDF();
                }}
                style={{ float: "right", marginTop: "-2%" }}
              >
                Next
              </Button>
            </React.Fragment>
          );
        default:
          throw new Error("Unknown step");
      }
  }
  










  //pdf

      const componentRef = useRef();

      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });
  
  
     const [hidden , setHidden]=useState(true)



  // handlers 



  const [nom, setNom] = useState("")
    const [prenom, setPrenom] = useState("");

    const [email, setEmail] = useState("");

    const [password, setpassword] = useState("");

    const [date ,setdate ]=useState("")
  
      const [sex, setsex] = React.useState("female");

      const handlesex = (event) => {
        setsex(event.target.value);
        console.log(sex)
      };

  








  //emailjs
  


   const [link, setLink] = useState("");

   const  handlesendemail = async() => {



      try {
    // Get the component reference
    const element = componentRef.current;

    // Configure options for html2pdf
    const opt = {
      margin: 1,
      filename: `${Date.now()}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    // Generate PDF using html2pdf
    const pdf = await html2pdf().set(opt).from(element).outputPdf("blob");

    // Create a blob from the PDF data
    const blob = new Blob([pdf], { type: "application/pdf" });

    // Upload PDF file to Firebase Storage
    const storageRef = reference(storage, `generated_pdfs/${Date.now()}.pdf`);
    const uploadTask = uploadBytesResumable(storageRef, blob);

    // Listen for state changes during the upload
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Calculate upload progress
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        // Handle any upload errors
        console.error(error);
        setErrors2({ upload: "An error occurred while uploading the PDF." });
      },
      () => {
        // When the upload is complete, get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // Use the download URL, e.g., save it to state or perform any further actions
          console.log("PDF uploaded successfully:", downloadURL);
          setLink(downloadURL);
        });
      }
    );
  } catch (error) {
    // Handle any unexpected errors
    console.error("Error generating or uploading PDF:", error);
    setErrors2({
      upload: "An error occurred while generating or uploading the PDF.",
    });
     }
     
    console.log("hellooasodaosdoasdo")
     // Replace this value with your EmailJS service ID
     const serviceID = "service_ygfhbln";
     // Replace this value with your EmailJS template ID
     const templateID = "template_prsi3cp";
     // Replace this value with your EmailJS user ID

     const userID = "TTtAkEj4xlim4k66W";
      console.log(Imgs[1])
     // Send the email using EmailJS
     emailjs
       .send(
         serviceID,
         templateID,
         {
           link: link,

           img1: Imgs[0],
           img2: Imgs[1],
           img3: Imgs[2],
           img4: Imgs[3],
           link: link,
         },
         userID
       )
       .then(
         (response) => {
           console.log("Email sent successfully:", response);
           // Reset the form field
           setLink("");
         },
         (error) => {
           console.error("Error sending email:", error);
         }
       );
   };
  return (
    <div>
      <Navb />

      <MDBContainer
        fluid
        style={{
          width: "100%",
          backgroundImage: `url(${bglogin})`,
        }}
      >
        <MDBRow
          className="d-flex justify-content-center align-items-center"
          style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
        >
          <MDBCol lg="8" style={{ marginTop: "10%" }}>
            <MDBCard
              className="my-5 rounded-3"
              style={{
                maxWidth: "1000px",
                marginLeft: "5%",
              }}
            >
              <Grid
                xs={12}
                md={12}
                lg={12}
                style={{
                  textAlign: "center",
                  fontFamily: " 'Bebas Neue', sans-serif",
                }}
              >
                {" "}
                <h1 style={{ marginTop: "3%" }}>
                  Prenez RDV et consulter en ligne des maintenant{" "}
                </h1>
              </Grid>
              <video autoPlay muted loop>
                <source src={vidbg} type="video/mp4" />
              </video>
              <MDBCardBody className="px-5">
                <h3 className="fw-bold mb-4 pb-2 pb-md-0 mb-md-5">
                  Registration Form
                </h3>

                <MDBRow>
                  <MDBCol md="6">
                    <MDBInput
                      wrapperClass="mb-4"
                      label="Nom"
                      size="lg"
                      id="form1"
                      type="text"
                      onChange={(e) => {
                        setNom(e.target.value);
                      }}
                    />
                  </MDBCol>

                  <MDBCol md="6">
                    <MDBInput
                      wrapperClass="mb-4"
                      label="Prenom"
                      size="lg"
                      id="form2"
                      type="text"
                      onChange={(e) => {
                        setPrenom(e.target.value);
                      }}
                    />
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="6">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="Date de naissance"
                          value={date}
                          onChange={(e) => {
                            setdate(e);
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </MDBCol>

                  <MDBCol md="6" className="mb-4">
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Genre
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={sex}
                        onChange={handlesex}
                      >
                        <FormControlLabel
                          value="Femme"
                          control={<Radio />}
                          label="Femme"
                        />
                        <FormControlLabel
                          value="Homme"
                          control={<Radio />}
                          label="Homme"
                        />
                      </RadioGroup>
                    </FormControl>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="6">
                    <MDBInput
                      wrapperClass="mb-4"
                      label="Email"
                      size="lg"
                      id="form4"
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </MDBCol>

                  <MDBCol md="6">
                    <MDBInput
                      wrapperClass="mb-4"
                      label="Phone Number"
                      size="lg"
                      id="form5"
                      type="rel"
                      value={password}
                      onChange={(e) => {
                        setpassword(e.target.value);
                      }}
                    />
                  </MDBCol>
                </MDBRow>
                <MDBCol md="6" sm="12">
                  <Box sx={{ display: "flex" }}>
                    <FormControl
                      sx={{ m: 3 }}
                      component="fieldset"
                      variant="standard"
                    >
                      <FormLabel component="legend">
                        Maladies Chroniques
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={db}
                              onChange={handlepathos}
                              name="db"
                            />
                          }
                          label="Diabete"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={hp}
                              onChange={handlepathos}
                              name="hp"
                            />
                          }
                          label="Hypertension"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={cho}
                              onChange={handlepathos}
                              name="cho"
                            />
                          }
                          label="Cholesterole"
                        />
                      </FormGroup>
                      <FormHelperText>Faites attention</FormHelperText>
                    </FormControl>
                    <FormControl
                      required
                      error={error}
                      component="fieldset"
                      sx={{ m: 3 }}
                      variant="standard"
                    >
                      <FormGroup style={{ marginTop: "18%" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={gilad}
                              onChange={handlepathos}
                              name="gilad"
                            />
                          }
                          label="autre"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={jason}
                              onChange={handlepathos}
                              name="jason"
                            />
                          }
                          label="autre"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={antoine}
                              onChange={handlepathos}
                              name="antoine"
                            />
                          }
                          label="autre"
                        />
                      </FormGroup>
                      <FormHelperText>Informations importantes</FormHelperText>
                    </FormControl>
                  </Box>
                </MDBCol>

                <Button
                  onClick={addTextField}
                  variant="contained"
                  color="primary"
                >
                  Ajouter Une allergie
                </Button>
                <form style={{ marginTop: "5%" }}>
                  {textFields.map((textField, index) => (
                    <TextField
                      key={textField.id}
                      label={`Allergie ${index + 1}`}
                      style={{ marginLeft: "3%", marginTop: "2%" }}
                      color="secondary"
                      value={textField.value}
                      onChange={(e) =>
                        handleTextFieldChange(index, e.target.value)
                      }
                    />
                  ))}
                </form>

                <MDBCol lg={6} md={6} style={{ marginTop: "5%" }}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Type De Greffe que vous desirer
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={Typegrf}
                        label="Type De Greffe que vous desirer"
                        onChange={handleTypegrf}
                      >
                        <MenuItem value={1}>Cheveux</MenuItem>
                        <MenuItem value={2}>Barbe</MenuItem>
                        <MenuItem value={3}>Sourcils</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </MDBCol>

                <MDBCol lg={12} md={12} style={{ marginTop: "5%" }}>
                  <MDBCol lg={12} md={12}>
                    <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
                      <Paper
                        className="Paper"
                        variant="outlined"
                        sx={{
                          my: { xs: 3, md: 6 },
                          p: { xs: 2, md: 3 },
                          boxShadow: "0 1px 1px rgb(0 0 0 / 0.2)",
                        }}
                      >
                        {Typegrf == 1 && (
                          <>
                            <Stepper activeStep={activeStep}></Stepper>
                            <React.Fragment>
                              {activeStep === steps.length ? (
                                <React.Fragment>
                                  <Typography variant="h5" gutterBottom>
                                    Merci Pour votre Demande.
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    Votre demande a été envoyé avec succès;
                                    merci😊.
                                  </Typography>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  {getStepContent(activeStep)}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  ></Box>
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          </>
                        )}

                        {Typegrf == 2 && (
                          <>
                            <React.Fragment>
                              <Grid container>
                                <Grid
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography
                                    variant="overline"
                                    display="block"
                                    gutterBottom
                                    style={{ marginTop: "10%" }}
                                  >
                                    Photo de face de votre visage{" "}
                                  </Typography>
                                  <img
                                    style={{ width: "25%" }}
                                    src="https://img.freepik.com/vecteurs-libre/gros-plan-visage-homme_98292-4059.jpg?size=338&ext=jpg&ga=GA1.1.632798143.1705276800&semt=ais"
                                  />
                                </Grid>
                                <Grid xs={12} md={6} lg={6}>
                                  <div className="App">
                                    <form onSubmit={formHandler}>
                                      <input
                                        type="file"
                                        className="input"
                                        style={{
                                          marginTop: "15%",
                                          width: "80%",
                                        }}
                                        onChange={() => {
                                          setimagepc(true);
                                        }}
                                      />
                                      {imagepc ? (
                                        <>
                                          <div>
                                            <button
                                              className="buttonIm"
                                              style={{
                                                border: "none",
                                                padding: "1%",
                                                marginTop: "2%",
                                                borderRadius: "12px",
                                                backgroundColor: "#34a8eb",
                                                fontFamily:
                                                  " 'Bebas Neue', sans-serif",
                                                color: "white",
                                              }}
                                              onClick={() => {
                                                uploadFiles();
                                                generatePDF();
                                                generatePDF();

                                              }}
                                              type="submit"
                                            >
                                              <UploadFileOutlined
                                                color="primary"
                                                sx={{
                                                  color: "white",
                                                  fontSize: "35px",
                                                }}
                                              />
                                              ENVOYER
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </form>
                                    <hr />
                                    {errors2.imagePC && (
                                      <p className="error">{errors2.imagePC}</p>
                                    )}

                                    <p>Uploading done {progress}%</p>
                                  </div>
                                  {photo ? (
                                    <>
                                      <div className="Li">
                                        <div
                                          className="boxclose"
                                          onClick={() => {
                                            setimagePC("");
                                            setphoto(false);
                                          }}
                                        ></div>
                                        <img
                                          className="imgV"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={imagePC}
                                          alt=""
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Grid>
                              </Grid>
                            </React.Fragment>
                          </>
                        )}
                        {Typegrf == 3 && (
                          <>
                            {" "}
                            <React.Fragment>
                              <Grid container>
                                <Grid
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography
                                    variant="overline"
                                    display="block"
                                    gutterBottom
                                    style={{ marginTop: "10%" }}
                                  >
                                    Photo de face de votre visage{" "}
                                  </Typography>
                                  <img
                                    style={{ width: "25%" }}
                                    src="https://img.freepik.com/vecteurs-libre/gros-plan-visage-homme_98292-4059.jpg?size=338&ext=jpg&ga=GA1.1.632798143.1705276800&semt=ais"
                                  />
                                </Grid>
                                <Grid xs={12} md={6} lg={6}>
                                  <div className="App">
                                    <form onSubmit={formHandler}>
                                      <input
                                        type="file"
                                        className="input"
                                        style={{
                                          marginTop: "15%",
                                          width: "80%",
                                        }}
                                        onChange={() => {
                                          setimagepc(true);
                                        }}
                                      />
                                      {imagepc ? (
                                        <>
                                          <div>
                                            <button
                                              className="buttonIm"
                                              style={{
                                                border: "none",
                                                padding: "1%",
                                                marginTop: "2%",
                                                borderRadius: "12px",
                                                backgroundColor: "#34a8eb",
                                                fontFamily:
                                                  " 'Bebas Neue', sans-serif",
                                                color: "white",
                                              }}
                                              onClick={() => {
                                                uploadFiles();
 generatePDF();
 generatePDF();
                                              }}
                                              type="submit"
                                            >
                                              <UploadFileOutlined
                                                color="primary"
                                                sx={{
                                                  color: "white",
                                                  fontSize: "35px",
                                                }}
                                              />
                                              ENVOYER
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </form>
                                    <hr />
                                    {errors2.imagePC && (
                                      <p className="error">{errors2.imagePC}</p>
                                    )}

                                    <p>Uploading done {progress}%</p>
                                  </div>
                                  {photo ? (
                                    <>
                                      <div className="Li">
                                        <div
                                          className="boxclose"
                                          onClick={() => {
                                            setimagePC("");
                                            setphoto(false);
                                          }}
                                        ></div>
                                        <img
                                          className="imgV"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={imagePC}
                                          alt=""
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Grid>
                              </Grid>

                             
                            </React.Fragment>
                          </>
                        )}
                      </Paper>
                    </Container>
                  </MDBCol>
                </MDBCol>

                <MDBBtn
                  className="mb-4"
                  size="lg"
                  onClick={() => {
                    setHidden(false);
                  }}
                  style={{ marginTop: "5%" }}
                >
                  Confirmer Vos Informations
                </MDBBtn>

                <MDBBtn
                  className="mb-4"
                  size="lg"
                  color="success"
                  onClick={() => {
                    generatePDF();
                    handlesendemail();
                  }}
                  style={{ marginTop: "5%", marginLeft: "5%" }}
                >
                  Envoyer La demande
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
            <MDBCol md={12} lg={12}></MDBCol>
          </MDBCol>
        </MDBRow>
      </MDBContainer>


        <div
          ref={componentRef}
          style={{
            fontFamily: " 'Montserrat', Sans-Serif",
            padding: "2%",
          }}
        >
          <Grid
            xs={12}
            md={12}
            lg={12}
            style={{
              textAlign: "center",
              fontFamily: " 'Bebas Neue', sans-serif",
            }}
          >
            {" "}
            <img src={watermark} style={{ width: "200px ", height: "200px" }} />
            <h2 style={{ marginTop: "3%", textDecoration: "underline" }}>
              Formulaire Patient{" "}
            </h2>
          </Grid>

          <div style={{ border: "1px solid black", padding: "2%" }}>
            <MDBRow>
              <MDBCol md="6">
                <h5 style={{ fontWeight: "bold" }}> Nom {nom}</h5>
              </MDBCol>

              <MDBCol md="6">
                <h5 style={{ fontWeight: "bold" }}>Prenom {prenom}</h5>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="6">
                <h5 style={{ fontWeight: "bold" }}>
                  Date De naissance : {dayjs(date.$d).format("DD/MM/YYYY")}{" "}
                </h5>
              </MDBCol>

              <MDBCol md="6" className="mb-4">
                <h6 className="fw-bold">Sex: {sex} </h6>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="6">
                <h5 style={{ fontWeight: "bold" }}>Email : {email}</h5>
              </MDBCol>

              <MDBCol md="6">Telephone : {password}</MDBCol>
            </MDBRow>
            <MDBCol md="6" sm="12"></MDBCol>

            <MDBCol md={6} lg={6}>
              <h5 style={{ fontWeight: "bold" }}>
                {" "}
                Liste Des maladies chroniques si presente :
              </h5>
              <MDBListGroup style={{ minWidthL: "22rem" }} light>
                {state.db ? (
                  <MDBListGroupItem>Diabete</MDBListGroupItem>
                ) : (
                  <></>
                )}

                {state.hp ? (
                  <MDBListGroupItem>Hypertension</MDBListGroupItem>
                ) : (
                  <></>
                )}

                {state.cho ? (
                  <MDBListGroupItem>Cholesterole</MDBListGroupItem>
                ) : (
                  <></>
                )}
              </MDBListGroup>
            </MDBCol>

            <MDBCol md={6} lg={6}>
              <h5 style={{ fontWeight: "bold" }}>
                {" "}
                Liste Des allergies si presente :
              </h5>
              <MDBListGroup style={{ minWidthL: "22rem" }} light>
                {textFields.map((alerg) => {
                  return <MDBListGroupItem>{alerg.value}</MDBListGroupItem>;
                })}
              </MDBListGroup>
            </MDBCol>

            <MDBCol lg={6} md={6} style={{ marginTop: "5%" }}>
              <Box sx={{ minWidth: 120 }}>
                <h5 style={{ fontWeight: "bold" }}>
                  {" "}
                  Type De Greffe desiré{" "}
                  {Typegrf == 1 && (
                    <h5 style={{ fontWeight: "bold" }}> Cheveux</h5>
                  )}{" "}
                  {Typegrf == 2 && (
                    <h5 style={{ fontWeight: "bold" }}> Barbe</h5>
                  )}
                  {Typegrf == 3 && (
                    <h5 style={{ fontWeight: "bold" }}> Sourcils</h5>
                  )}
                </h5>
              </Box>
            </MDBCol>
          </div>
        </div>
      
    </div>
  );
}


const mapStateToProps = state=>({
  isAuthenticated:state.auth.isAuthenticated
})

Login.propTypes ={
  login :PropTypes.func.isRequired,
  isAuthenticated:PropTypes.bool,

}

export default(Login);
